import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'
import ToastService from 'primevue/toastservice'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import { GesturePlugin } from '@vueuse/gesture'
import RightMessageTheme from './assets/theme/primevue'
import router from '@/router'

import App from '@/App.vue'
import './assets/css/app.scss'
import './assets/css/validation.css'
import Ripple from 'primevue/ripple'
import Tooltip from 'primevue/tooltip'
import 'iconify-icon'
import { initializeRealtimeConnectionMonitoring } from './services/pusher'
import { initializeSentry } from './services/sentry'

const pinia = createPinia()
const app = createApp(App)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError: false
    }
  }
})
initializeSentry(app, router)

app.use(pinia)
initializeRealtimeConnectionMonitoring()

// Handle chunk loading errors from deploys — show banner instead of alert
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.toString() ?? ''
  if (
    reason.includes('TypeError: Failed to fetch') ||
    reason.includes('Failed to fetch dynamically imported module') ||
    reason.includes('Importing a module script failed')
  ) {
    const systemStore = useSystemStore()
    systemStore.newVersionAvailable = true
  }
})

app.use(VueQueryPlugin, { queryClient })
app.use(router)
app.use(PrimeVue, {
  unstyled: true,
  pt: RightMessageTheme
})
app.use(ConfirmationService)
app.use(GesturePlugin)
app.use(ToastService)
app.directive('ripple', Ripple)
app.directive('tooltip', Tooltip)
app.mount('#app')

// Initialize system-level WebSocket channel and version polling
const systemStore = useSystemStore()
systemStore.initSystemChannel()
systemStore.startVersionPolling()
